<div class="missions-container">
  <div class="missions-header missions-title">Suas missões</div>
  <div class="missions-header missions-subtitle">Conclua as missões e libere os benefícios disponíveis</div>
  <div class="missions-progress-box" *ngIf="missionsCompletedCount < 3">
    <span class="missions-progress-text">
      {{ missionsCompletedCount }}/3 missões concluídas
    </span>
    <div class="missions-progress-bars">
      <div class="missions-progress-bar" [ngClass]="{'completed': missionsCompletedCount > 0}"></div>
      <div class="missions-progress-bar" [ngClass]="{'completed': missionsCompletedCount > 1}"></div>
      <div class="missions-progress-bar" [ngClass]="{'completed': missionsCompletedCount > 2}"></div>
    </div>
  </div>
  <div class="missions-progress-success" *ngIf="missionsCompletedCount > 2">
    <span class="missions-progress-success-text">
      Boa! Você está em dia. Aguarde novas missões para liberar mais benefícios
    </span>
  </div>
  <div class="missions-items-list">
    <ng-container *ngFor="let mission of missions; let i = index">
      <div class="missions-item-container-with-chevron"
           tabindex="0"
           role="button"
           (click)="i === 0 ? goToMissionLogin() : i === 1 ? (isClientNotEnrolled ? goToMissionTakeTakeExclusiveOffers() : goToMissionEnroll()) : goToMissionShareWithFriends()"
           (keydown)="($event.key === 'Enter' || $event.key === ' ') && (i === 0 ? goToMissionLogin() : i === 1 ? (isClientNotEnrolled ? goToMissionTakeTakeExclusiveOffers() : goToMissionEnroll()) : goToMissionShareWithFriends())">
        <div class="missions-item-container">
            <img [src]="mission.image" alt="Imagen Mission" class="mission-img" />
            <div class="mission-title">{{ mission.title }}</div>
            <div class="mission-subtitle">{{ mission.subtitle }}</div>
            <div class="mission-status"
              [ngClass]="i === 0 ? mission.statusClass(isLoggedIn) : i === 1 ? mission.statusClass(isClientNotEnrolled ? isTakeExclusiveOffers : isEnrolled) : mission.statusClass(isShareWithFriends)">
              <span class="mission-status-text">
                 {{ i === 0 ? mission.status(isLoggedIn) : i === 1 ? mission.status(isClientNotEnrolled ? isTakeExclusiveOffers : isEnrolled) : mission.status(isShareWithFriends) }}
              </span>
            </div>
        </div>
        <div class="mission-chevron-side" *ngIf="(i === 0 && !isLoggedIn) || (i === 1 && !isEnrolled) || (i === 2 && !isShareWithFriends)">
          <div class="mission-chevron-box">
            <img src="assets/resources/images/ifood-landing/mission-chevron.svg" alt="Ir a missão" />
          </div>
        </div>
      </div>
      <div class="missions-item-divider" *ngIf="i < missions.length - 1"></div>
    </ng-container>
  </div>

   <!-- Toast EVA para compartilhar com amigos -->
  <div *ngIf="showShareToast" role="presentation" class="eva-3-message eva-3-message--toast -eva-3-shadow-static -success" style="position: fixed; top: 24px; left: 50%; transform: translateX(-50%); z-index: 9999; min-width: 320px; max-width: 90vw;">
    <i class="eva-3-icon-cross message-close" role="button" tabindex="0" (click)="closeShareToast()" aria-label="Cerrar notificación"></i>
    <div class="message-icon-container">
      <i class="eva-3-icon-checkmark-circle-filled message-icon"></i>
    </div>
    <div class="message-body">
      <div class="eva-3-body-2 message-text">Link do benefício copiado! Agora comece a enviar para seus amigos
      </div>
    </div>
    <span class="message-loader"></span>
  </div>
  